
<template>
  <div
    class="d-flex flex-column h-100 px-3"
    style="overflow: auto; min-width: 50vw; min-height: 50vh"
  >
    <div class="d-flex flex-column pt-3 pb-3 justify-content-center">
      <h2 class="d-flex justify-content-center mb-3">
        {{ "Conveniq receipt commands v0.2" }}
      </h2>

      <div
        class="d-flex flex-row justify-content-center w-100 mt-3"
        style="flex-wrap: wrap; gap: 20px"
      >
        <base-button
          v-for="(command, index) in methods"
          :key="index"
          :variant="'pure'"
          className="v-btn v-theme--ORANGE_THEME bg-success v-btn--density-default v-btn--size-default v-btn--variant-flat"
          @click="sendCommand(command)"
        >
          <h2>{{ command.name }}</h2>
        </base-button>
      </div>
    </div>

    <spinner v-if="spinnerShow"></spinner>
    <BaseDialog :modelValue="showDialogue">
      <h2 class="d-flex">
        {{ dialogueMessage }}
      </h2>
      <div
        class="d-flex flex-row justify-content-center"
        style="flex-wrap: wrap; gap: 20px"
      >
        <base-button
          :variant="'pure'"
          className="v-btn v-theme--ORANGE_THEME bg-success v-btn--density-default v-btn--size-default v-btn--variant-flat"
          @click="_confirm"
        >
          <h2>{{ okButton }}</h2>
        </base-button>

        <base-button
          :variant="'pure'"
          className="v-btn v-theme--ORANGE_THEME bg-error v-btn--density-default v-btn--size-default v-btn--variant-flat"
          @click="_cancel"
        >
          <h2>{{ cancelButton }}</h2>
        </base-button>
      </div>
    </BaseDialog>
  </div>
</template>


<script>
import BaseButton from "@/components/BaseButton.vue";
import Spinner from "../Spinner.vue";
import BaseDialog from "@/components/BaseDialog.vue";
import EntityApi from "@/api/entityApi";

export default {
  name: "receiptCommands-page",
  props: {
    id: {
      type: [Number, String],
      required: false,
    },
    entity: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
    },
  },
  emits: ["closeModalf"],
  components: {
    BaseButton,
    Spinner,
    BaseDialog,
  },
  data() {
    return {
      spinnerShow: false,
      methods: [
        { name: "Update receipt", value: "update_receipt" },
        { name: "Confirm receipt", value: "confirm_receipt" },
        {
          name: "Create fiscal transaction",
          value: "create_fiscal_transaction",
        },
        { name: "Upload receipt (beta v1)", value: "upload_receipt" },
      ],

      showDialogue: false,
      dialogueMessage: "",
      okButton: "",
      cancelButton: "",
      resolvePromise: undefined,
      rejectPromise: undefined,
    };
  },
  methods: {
    sendCommand(operation) {
      if (!operation) {
        this.$notify(
          {
            group: "alert",
            type: "error",
            title: this.$t("lables.error"),
            text: "No operation for action",
          },
          3000
        );
      }
      let url = `${process.env.VUE_APP_API_URL}/api/v1/conveniq/client_session_command?receipt_id=${this.id}&command_type=${operation.value}`;

      this.show({
        message: this.$t(
          "You want to send to conveniq command " + operation.name + "?"
        ),
      }).then((data) => {
        if (data) {
          this.spinnerShow = true;
          EntityApi.sendCustomRequest(url, "post", null)
            .then((data) => {
              if (data) {
                this.$notify(
                  {
                    group: "alert",
                    type: "info",
                    title: this.$t("lables.success"),
                    text: "Query sended to conveniq, but result is not known. Its first incarnation of this feature, no feedback",
                  },
                  8000
                );
              } else {
                this.$notify(
                  {
                    group: "alert",
                    type: "error",
                    title: this.$t("lables.opps"),
                    text: "Query NOT sended to conveniq",
                  },
                  3000
                );
              }

              this.spinnerShow = false;
            })
            .catch(() => {
              this.spinnerShow = false;
              this.$notify(
                {
                  group: "alert",
                  type: "error",
                  title: this.$t("lables.opps"),
                  text: "Query NOT sended to conveniq",
                },
                3000
              );
            });
        }
      });
    },

    show(opts = {}) {
      this.dialogueMessage = opts?.message ? opts.message : "Are you sure?";
      this.okButton = opts?.okButton ? opts.okButton : "Yes";
      this.cancelButton = opts?.cancelButton ? opts.cancelButton : "No";

      this.showDialogue = true;

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    _confirm() {
      this.showDialogue = false;
      this.resolvePromise(true);
    },
    _cancel() {
      this.showDialogue = false;
      this.resolvePromise(false);
    },
  },
  mounted() {},
  beforeUnmount() {},
  sockets: {},
  computed: {},
  watch: {},
};
</script>
<style lang="scss" scoped>
</style>